import axios from '../axios'
import Qs from 'qs'
/**
 * 注册
 * @param {*} data
 */
export const agencyInfoRegister = data => {
  return axios({
    url: '/agency/agencyInfo/register',
    method: 'post',
    data,
    headers: {
      isToken: false
    }
  })
}

/**
 * 发送重置密码的验证码
 * @param {*} data
 */
export const forgotPwdSms = data => {
  return axios({
    url: '/auth/forgot_pwd_sms',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 重置密码
 * @param {*} data
 */
export const forgotPwd = data => {
  return axios({
    url: '/auth/forgot_pwd',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 登录
 * @param {*} data
 */
export const oauthToken = data => {
  return axios({
    url: '/auth/oauth/token',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 退出登录
 * @param {*} data
 */
export const oauthLogout = data => {
  return axios({
    url: '/auth/oauth/logout',
    method: 'post'
  })
}
/**
 * 获取用户的基本信息
 * @param {*} data
 */
export const userInfo = data => {
  return axios({
    url: '/auth/self_info',
    method: 'get'
  })
}

/**
 * 发送手机验证码
 * @param {*} data
 */
export const smsCode = data => {
  return axios({
    url: '/auth/sms/bind',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 绑定手机号
 * @param {*} data
 */
export const bindPhone = data => {
  return axios({
    url: '/auth/bind/phone',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const sendRegisterSms = data => {
  return axios({
    url: '/auth/sms/register',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// /**
//  * 发送邮箱注册验证码
//  * @param {*} email 
//  */
// export const sendRegistEmailSms = email => {
//   return axios({
//     url: `/auth/sms/sendRegistEmailSms/${email}`,
//     method: 'post',
//     headers: {
//       isToken: false
//     }
//   })
// }

/**
 * 通过验证码注册账号
 * @param {*} data 
 */
export const registBySmsCode = data => {
  return axios({
    url: `/auth/registBySmsCode`,
    method: 'POST',
    data,
    headers: {
      isToken: false
    }
  })
}

/**
 * 修改密码
 * @param {*} data 
 */
export const changePassword = data => {
  return axios({
    url: `/auth/change_password?oldPassword=` + data.oldPassword + '&newPassword=' + data.newPassword,
    method: 'POST',
    data
  })
}


/**
 * 修改密码
 * @param {*} data 
 */
export const changeAgencyPassword = data => {
  return axios({
    url: `/auth/change_agency_password?accountId=` + data.accountId + '&newPassword=' + data.newPassword,
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/comm/http/modules/user.js